import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AccountContext } from "~/contexts/Account";

// Clarity starts a new session after ~30 minutes of inactivity even when the
// tab stays open, and identify/custom tags are per-session — so a login-time
// identify alone leaves those later sessions anonymous. Re-fire it on every
// route change and whenever the tab becomes visible again, so every Clarity
// session of an authenticated user carries the email.
export const useClarityIdentify = () => {
  const { account } = useContext(AccountContext);
  const location = useLocation();
  const email = account?.email;

  useEffect(() => {
    if (!email) return;

    const identify = () => {
      window.clarity?.("identify", email, null, null, email);
      window.clarity?.("set", "user_email", email);
    };

    identify();

    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") identify();
    };
    document.addEventListener("visibilitychange", onVisibilityChange);
    return () =>
      document.removeEventListener("visibilitychange", onVisibilityChange);
  }, [email, location.pathname]);
};
